import { useState } from 'react'
import { remitosApi } from '../../api/remitos'
import { colors, font, text } from '../../design/tokens'

// Imprimir + confirmar un remito desde el celular (Martin, 30 sep 2026:
// "dejame confirmar y mandar a logística"). Mismas reglas que el detalle de
// escritorio, que viven en el backend (RemitoController::confirmar/imprimir):
//  - un T90 —retiro incluido— no se confirma sin estar impreso (el papel es
//    el control de la preparación);
//  - no se imprime con el número provisorio R000xxx: hay que esperar el de
//    Presea;
//  - el remito libre (sin NV) no se confirma a mano: lo confirma Presea.
// Confirmar = pasa a logística (o a Retiros por sucursal si retira).
export default function AccionesRemitoMovil({ remito, onCambio }) {
  const [trabajando, setTrabajando] = useState(null)
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')

  if (!remito || remito.estado !== 'ingresado' || !remito.nota_venta_id) return null

  const esT90 = Number(remito.transporte) === 90
  const impreso = (remito.impresiones_count || 0) > 0
  const numeroProvisorio = /^R\d+$/.test(String(remito.numero_presea || ''))

  const imprimir = async () => {
    setError(''); setOk('')
    // Safari (iPhone) bloquea window.open después de un await: la pestaña se
    // abre en el toque y el PDF se carga cuando llega.
    const pestana = window.open('', '_blank')
    setTrabajando('imprimir')
    try {
      const { data } = await remitosApi.imprimir(remito.id)
      const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
      if (pestana) pestana.location.href = url
      else window.location.href = url
      setTimeout(() => URL.revokeObjectURL(url), 60000)
      setOk('Remito impreso — impresión registrada. Ya lo podés confirmar.')
      onCambio?.()
    } catch (err) {
      pestana?.close()
      setError((await mensajeDeBlob(err)) || 'No se pudo imprimir el remito.')
    } finally { setTrabajando(null) }
  }

  const confirmar = async () => {
    setError(''); setOk('')
    setTrabajando('confirmar')
    try {
      await remitosApi.confirmar(remito.id)
      setOk(remito.retira ? 'Confirmado — pasa a Retiros por sucursal.' : 'Confirmado — pasa a logística.')
      onCambio?.()
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo confirmar.')
    } finally { setTrabajando(null) }
  }

  return (
    <div style={caja}>
      {esT90 && numeroProvisorio ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ flex: 1, fontSize: text.sec, color: colors.textSec, fontFamily: font.sans }}>
            ⏳ Esperando el número de remito de Presea para imprimir.
          </span>
          <button style={btnSec} onClick={() => onCambio?.()}>↻ Actualizar</button>
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8 }}>
          {esT90 && !impreso && (
            <button style={{ ...btnPri, flex: 1 }} disabled={!!trabajando} onClick={imprimir}>
              {trabajando === 'imprimir' ? 'Imprimiendo…' : '🖨 Imprimir remito'}
            </button>
          )}
          <button
            style={{ ...(esT90 && !impreso ? btnSec : btnPri), flex: 1, opacity: esT90 && !impreso ? 0.55 : 1 }}
            disabled={!!trabajando || (esT90 && !impreso)}
            onClick={confirmar}
          >
            {trabajando === 'confirmar' ? 'Confirmando…' : '✓ Confirmar → logística'}
          </button>
        </div>
      )}
      {esT90 && !impreso && !numeroProvisorio && (
        <p style={nota}>Primero se imprime: el papel es el control de la preparación.</p>
      )}
      {!esT90 && Number(remito.transporte) === 80 && (
        <p style={nota}>T80: después de confirmar, la planilla de envío (NEs) se carga desde el escritorio.</p>
      )}
      {error && <p style={{ ...nota, color: colors.err }}>{error}</p>}
      {ok && <p style={{ ...nota, color: colors.ok }}>✓ {ok}</p>}
    </div>
  )
}

async function mensajeDeBlob(err) {
  const data = err.response?.data
  if (data instanceof Blob) {
    try {
      const t = await data.text()
      return JSON.parse(t).message || null
    } catch { return null }
  }
  return data?.message || null
}

const caja = { marginTop: 8, padding: '10px 12px', borderRadius: 12, background: colors.bgSoft, border: `1px solid ${colors.borderSoft}` }
const btnBase = {
  padding: '11px 10px', borderRadius: 10, fontSize: 14, fontWeight: 700, fontFamily: font.sans,
  cursor: 'pointer', WebkitTapHighlightColor: 'rgba(15,23,42,0.06)',
}
const btnPri = { ...btnBase, border: 'none', background: colors.primary, color: '#fff' }
const btnSec = { ...btnBase, border: `1px solid ${colors.border}`, background: colors.bg, color: colors.textSec, flexShrink: 0 }
const nota = { margin: '8px 2px 0', fontSize: 12, color: colors.textMeta, fontFamily: font.sans, lineHeight: 1.4 }
